import { Component, Input, OnChanges } from '@angular/core';
import { NavItem } from './nav-item';
import { Router } from '@angular/router';
import { NavService } from '../../../../services/nav.service';

@Component({
  selector: 'app-nav-item',
  templateUrl: './nav-item.component.html',
  styleUrls: [],
})
export class AppNavItemComponent implements OnChanges {
  @Input() item: NavItem | any;
  @Input() depth: any;

  constructor(public navService: NavService, public router: Router) {
    if (this.depth === undefined) {
      this.depth = 0;
    }
  }

  ngOnChanges() {
    this.navService.currentUrl.subscribe((url: string) => {
      if (this.item.route && url) {
      }
    });
  }

  
  selectedRoute: string = '';

  onItemSelected(item: NavItem) {
    if (!item.children || !item.children.length) {
      this.selectedRoute = item.route ?? ''; // Ensure selectedRoute is always a string
      this.router.navigate([item.route]);
      this.navService.closeSidenav();
    }
  

    // scroll
    document.querySelector('.page-wrapper')?.scroll({
      top: 0,
      left: 0,
    });
  }
  parentRoutes: { [key: string]: string[] } = {
    '/ui-components/riskprofile': [
      '/ui-components/riskprofilereport'

    ],
    '/ui-components/badge': [
      '/ui-components/mfnetposition',
      '/ui-components/mf_transaction',
      '/ui-components/MfCapitalgainComponent',
      '/ui-components/Mfsystematicschemes'
    ],
    '/ui-components/equity': [
      '/ui-components/equitytransaction',
      '/ui-components/equitycapitalgain',
      '/ui-components/equitynetposition',
      '/ui-components/AddCoordinates'
    ],
    '/ui-components/fixedincomedashboard': [
      '/ui-components/fixedincometransaction',
      '/ui-components/fixedincomeholdings'
    ],
    '/ui-components/otherassetdashboard': [
      '/ui-components/otherassetnetposition',
      '/ui-components/otherassettransaction'
    ],
    '/ui-components/mfreport': [
      '/ui-components/eqreport'
    ],
    '/ui-components/calculator': [
      '/ui-components/sipcal',
      '/ui-components/lumpsumcal',
      '/ui-components/emical',
      '/ui-components/gratuitycal',
      '/ui-components/fdcal',
      '/ui-components/rdcal'
    ]
  };

  isMenuActive(route: string): boolean {
    const currentUrl = this.router.url;

    // Check if the main route is active
    if (currentUrl.startsWith(route)) {
      return true;
    }

    // Check if any sub-routes belong to this parent
    return this.parentRoutes[route]?.some(subRoute => currentUrl.startsWith(subRoute)) || false;
  }
}
